import { render, staticRenderFns } from "./Offshore.vue?vue&type=template&id=11b2e1c4&scoped=true"
import script from "./Offshore.vue?vue&type=script&lang=js"
export * from "./Offshore.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=11b2e1c4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b2e1c4",
  null
  
)

export default component.exports